<script>
  import { btn } from "./BaseButton.style";
  export let textAlign = "text-left";

  export let style = "";
</script>

<button class={`${btn} ${textAlign} ${style}`} on:click>
  <slot />
</button>
